import type { ColumnConfig } from '@/components/configure-columns-dialog';

// Default column configuration for the Assets screen
export const DEFAULT_ASSET_COLUMNS: ColumnConfig[] = [
  // Default columns (visible by default)
  { id: 'code', label: 'Code', visible: true, order: 0, group: 'default' },
  { id: 'name', label: 'Asset Name', visible: true, order: 1, group: 'default' },
  { id: 'category', label: 'Category', visible: true, order: 2, group: 'default' },
  { id: 'location', label: 'Location', visible: true, order: 3, group: 'default' },
  { id: 'status', label: 'Status', visible: true, order: 4, group: 'default' },
  { id: 'serialNumber', label: 'Serial Number', visible: true, order: 5, group: 'default' },
  { id: 'acquisitionCost', label: 'Acquisition Cost', visible: true, order: 6, group: 'default' },
  { id: 'netBookValue', label: 'Net Book Value', visible: true, order: 7, group: 'default' },
  { id: 'acquisitionDate', label: 'Acquisition Date', visible: true, order: 8, group: 'default' },
  
  // Optional columns (hidden by default)
  { id: 'description', label: 'Description', visible: false, order: 9, group: 'optional' },
  { id: 'manufacturer', label: 'Manufacturer', visible: false, order: 10, group: 'optional' },
  { id: 'model', label: 'Model', visible: false, order: 11, group: 'optional' },
  { id: 'assignedTo', label: 'Assigned To', visible: false, order: 12, group: 'optional' },
  { id: 'department', label: 'Department', visible: false, order: 13, group: 'optional' },
  { id: 'accumulatedDepreciation', label: 'Accumulated Depreciation', visible: false, order: 14, group: 'optional' },
  { id: 'depreciationMethod', label: 'Depreciation Method', visible: false, order: 15, group: 'optional' },
  { id: 'usefulLife', label: 'Useful Life', visible: false, order: 16, group: 'optional' },
  { id: 'warrantyExpiryDate', label: 'Warranty Expiry', visible: false, order: 17, group: 'optional' },
  { id: 'insuranceExpiryDate', label: 'Insurance Expiry', visible: false, order: 18, group: 'optional' },
  { id: 'quantity', label: 'Quantity', visible: false, order: 19, group: 'optional' },
  { id: 'barcode', label: 'Barcode', visible: false, order: 20, group: 'optional' },
  { id: 'barcodeValue', label: 'Barcode Value', visible: false, order: 21, group: 'optional' },
];

export const ASSET_COLUMNS_STORAGE_KEY = 'assets-columns-config';
